(function () {
  'use strict';

  var root = document.getElementById('wl-subscriptions');

  if (!root || root.dataset.wlSubscriptionsReady === 'true') {
    return;
  }

  root.dataset.wlSubscriptionsReady = 'true';

  var purchaseButtons = Array.prototype.slice.call(
    root.querySelectorAll('[data-purchase-product]')
  );

  var restoreButton = root.querySelector('#wlRestorePurchases');
  var statusBox = root.querySelector('#wlSubscriptionStatus');
  var statusTimer = null;
  var activeButton = null;

  function showStatus(message, type, duration) {
    if (!statusBox) {
      return;
    }

    window.clearTimeout(statusTimer);

    statusBox.textContent = message;
    statusBox.hidden = false;
    statusBox.classList.remove('is-error', 'is-success');

    if (type === 'error') {
      statusBox.classList.add('is-error');
    }

    if (type === 'success') {
      statusBox.classList.add('is-success');
    }

    statusTimer = window.setTimeout(function () {
      statusBox.hidden = true;
    }, typeof duration === 'number' ? duration : 4200);
  }

  function setButtonLoading(button, loading) {
    if (!button) {
      return;
    }

    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function planFromButton(button) {
    var explicitPlan = String(
      button.getAttribute('data-plan') || ''
    ).toLowerCase();

    if (explicitPlan === 'yearly' || explicitPlan === 'monthly') {
      return explicitPlan;
    }

    var productId = String(
      button.getAttribute('data-purchase-product') || ''
    ).toLowerCase();

    return productId.indexOf('yearly') !== -1
      ? 'yearly'
      : 'monthly';
  }

  function openNativePaywall(plan) {
    var safePlan = plan === 'yearly' ? 'yearly' : 'monthly';
    var deepLink = 'waglife://plus?plan=' + encodeURIComponent(safePlan);

    /*
      ContentView.swift already intercepts this URL inside the WagLife WKWebView
      and presents the native WagLifePlusPaywall sheet.
    */
    window.location.assign(deepLink);
  }

  function beginPurchase(button) {
    if (!button || activeButton) {
      return;
    }

    var productId = button.getAttribute('data-purchase-product');

    if (!productId) {
      showStatus(
        'This subscription is not configured correctly.',
        'error',
        6000
      );
      return;
    }

    var plan = planFromButton(button);

    activeButton = button;
    setButtonLoading(button, true);

    showStatus(
      'Opening WagLife Plus securely with Apple…',
      'neutral',
      3500
    );

    try {
      openNativePaywall(plan);

      /*
        The WKWebView cancels the custom-scheme navigation after opening the
        native sheet, so release the web button shortly afterward.
      */
      window.setTimeout(function () {
        if (activeButton === button) {
          setButtonLoading(button, false);
          activeButton = null;
        }
      }, 1400);
    } catch (error) {
      setButtonLoading(button, false);
      activeButton = null;

      showStatus(
        'WagLife Plus subscriptions are available inside the WagLife iPhone app.',
        'error',
        6500
      );

      console.error('WagLife paywall deep-link error:', error);
    }
  }

  purchaseButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      beginPurchase(button);
    });
  });

  if (restoreButton) {
    restoreButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (restoreButton.disabled) {
        return;
      }

      restoreButton.disabled = true;
      restoreButton.textContent = 'Opening…';

      showStatus(
        'Opening the secure Apple subscription screen. Tap Restore Purchases there.',
        'neutral',
        5000
      );

      try {
        /*
          The existing native paywall already contains the working
          Restore Purchases button, so open that paywall directly.
        */
        openNativePaywall('monthly');

        window.setTimeout(function () {
          restoreButton.disabled = false;
          restoreButton.textContent = 'Restore Purchases';
        }, 1400);
      } catch (error) {
        restoreButton.disabled = false;
        restoreButton.textContent = 'Restore Purchases';

        showStatus(
          'Restore Purchases is available inside the WagLife iPhone app.',
          'error',
          6500
        );

        console.error('WagLife restore deep-link error:', error);
      }
    });
  }

  /*
    The native app already sends this event whenever StoreKit entitlement
    changes. Update the homepage section when WagLife Plus becomes active.
  */
  window.addEventListener(
    'waglife:plus-entitlement-changed',
    function (event) {
      var isActive = Boolean(
        event &&
        event.detail &&
        event.detail.active
      );

      root.classList.toggle(
        'has-active-subscription',
        isActive
      );

      if (isActive) {
        showStatus(
          'WagLife Plus is active. Welcome to the family!',
          'success',
          6500
        );
      }
    }
  );

  /*
    ContentView.swift may inject this value before this asset finishes loading.
  */
  if (window.WAGLIFE_PLUS_ACTIVE === true) {
    root.classList.add('has-active-subscription');
  }

  /*
    Clean up any temporary loading state when the page becomes visible again
    after the native sheet closes.
  */
  document.addEventListener('visibilitychange', function () {
    if (
      document.visibilityState === 'visible' &&
      activeButton
    ) {
      setButtonLoading(activeButton, false);
      activeButton = null;
    }
  });

  window.addEventListener('pageshow', function () {
    if (activeButton) {
      setButtonLoading(activeButton, false);
      activeButton = null;
    }

    if (restoreButton) {
      restoreButton.disabled = false;

      if (restoreButton.textContent === 'Opening…') {
        restoreButton.textContent = 'Restore Purchases';
      }
    }
  });
})();
